export const API_URL = "https://charts.lockedtrade.com/api";
export const WS_URL = "wss://locktrade.spr.p3.tiktalik.io/ws/ws";
export const INITIAL_CANDLES = 200;

export const BACKEND_API_URL = "https://charts.lockedtrade.com/auth";

export const BASIC_ID="price_1RaaLxKrjx03t3ccrOHasl5i"
export const PRO_MONTHLY_ID="price_1RaaJkKrjx03t3ccgMwNQnzH"
export const PRO_YEARLY_ID="price_1RaaHBKrjx03t3cc7xbGBDtf"
export const EXPERT_MONTHLY_ID="price_1RaaH9Krjx03t3ccorVMYl47"
export const EXPERT_YEARLY_ID="price_1RaaH7Krjx03t3ccfgYdgI3K"

export const STRIPE_PORTAL_URL="https://billing.stripe.com/p/login/7sYcN65IUc8Mfq40yQ0x200"
